import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

const StatCard = ({ title, value, subtitle, icon: Icon, trend, gradient = false }) => {
  const gradientClass = gradient ? 'gradient-primary' : '';
  const textColorClass = gradient ? 'text-white' : 'text-text-primary';
  const subtitleColorClass = gradient ? 'text-white/80' : 'text-text-secondary';

  return (
    <div
      className={`rounded-lg p-4 sm:p-6 border border-border shadow-card hover:shadow-card-hover transition-all ${gradientClass} ${
        !gradient ? 'bg-background-surface' : ''
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <p className={`text-xs sm:text-sm font-medium ${subtitleColorClass}`}>
            {title}
          </p>
          <p className={`text-2xl sm:text-3xl font-bold mt-1 sm:mt-2 ${textColorClass} truncate`}>
            {typeof value === 'number' ? value.toLocaleString() : value}
          </p>
          {subtitle && (
            <p className={`text-xs sm:text-sm mt-1 sm:mt-2 ${subtitleColorClass} truncate`}>
              {subtitle}
            </p>
          )}
          {trend && (
            <div className={`flex items-center gap-1 mt-1 sm:mt-2 text-xs sm:text-sm font-medium ${
              trend > 0 ? 'text-success' : 'text-error'
            }`}>
              {trend > 0 ? (
                <TrendingUp size={14} className="sm:w-4 sm:h-4" />
              ) : (
                <TrendingDown size={14} className="sm:w-4 sm:h-4" />
              )}
              <span>{Math.abs(trend)}%</span>
            </div>
          )}
        </div>
        {Icon && (
          <div className={`p-2 sm:p-3 rounded-lg flex-shrink-0 ${
            gradient ? 'bg-white/10' : 'bg-primary/10'
          }`}>
            <Icon size={20} className={`sm:w-6 sm:h-6 ${gradient ? 'text-white' : 'text-primary'}`} />
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
